// AiTypingIndicator.jsx

import React from 'react';

// Constants
import { AI_TITLE } from 'spaces/constants/aiConstants';

// CSS
import './AiTypingIndicator.css';

const AiTypingIndicator = React.memo(({ pendingCount = 1 }) => {
  // ----- CONTEXT ----- //

  const label = pendingCount > 1
    ? `${AI_TITLE} is working on ${pendingCount} requests`
    : `${AI_TITLE} is typing`;

  // ----- RENDER ----- //

  return (
    <div
      className="ai-typing-indicator"
      aria-live="polite"
      aria-label={label}
    >
      {/* AVATAR */}
      <div
        className="ai-typing-indicator__avatar"
        aria-hidden
      >
        AI
      </div>

      {/* BODY */}
      <div className="ai-typing-indicator__body">
        {/* NAME */}
        <span
          className="ai-typing-indicator__name"
        >
          {AI_TITLE}
        </span>
        {/* BUBBLE */}
        <div
          className="ai-typing-indicator__bubble"
        >
          {/* DOT */}
          <span className="ai-typing-indicator__dot" />
          {/* DOT */}
          <span className="ai-typing-indicator__dot" />
          {/* DOT */}
          <span className="ai-typing-indicator__dot" />
        </div>
      </div>
    </div>
  );
});

// Dev Tools
AiTypingIndicator.displayName = 'AiTypingIndicator';

export default AiTypingIndicator;
